import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { registerSW } from 'virtual:pwa-register'

// Register PWA service worker — auto-update silently
registerSW({
  onNeedRefresh() {
    // New content available; update automatically
    console.log('[PWA] New content available, updating...')
  },
  onOfflineReady() {
    console.log('[PWA] App ready to work offline')
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
